const archiAppSectionsBasePath = '/archi-app-sections';

export class ArchiAppSectionPath {
  static index() {
    return archiAppSectionsBasePath;
  }
}
